import { withNamespaces } from "react-i18next";
import Accordion from 'react-bootstrap/Accordion';
import GeneralInformationImage from "src/modules/3rd-party-management/assets/images/general-information.svg";
import { Badge, Col, Label, Row } from "reactstrap";
import DateUtils from "src/services/utils/DateUtils";
import { INTERNATIONAL_DATE_FORMAT } from 'src/common/constants';
import {
    formatAddress,
    formatMoney,
    parseHandelsregisterOrganizationData
} from "../../helpers";

const GeneralInfo = ({
    t,
    activeAccordion,
    setActiveAccordion,
    detailsQuery
}) => {
    const dateUtils = new DateUtils();
    const data = parseHandelsregisterOrganizationData(detailsQuery?.data?.company);

    if (!data) {
        return null;
    }

    const status = (data.status || '').toString().toUpperCase();
    const isActive = status === 'ACTIVE';
    const registration = data.registration || {};
    const capital = data.capital?.current;

    return (
        <Accordion.Item
            onClick={() => setActiveAccordion('general-info')}
            className={activeAccordion === 'general-info' ? 'active' : ''}
            eventKey={'general-info'}
        >
            <Accordion.Header>
                <img src={GeneralInformationImage} alt="" />
                <span>{t('Company Information')}</span>
            </Accordion.Header>

            <Accordion.Body>
                <Row className="g-3 mb-4">
                    <Col sm="12" className="mb-3">
                        <h5>
                            {data.name || '-'}
                            {status && (
                                <Badge className={`${isActive ? 'bg-success' : 'bg-secondary'} ms-2`}>
                                    {t(status)}
                                </Badge>
                            )}
                        </h5>
                    </Col>
                    <Col md="6">
                        <dl>
                            <Label>{t('Legal Form')}</Label>
                            <p className="mb-2">{data.legal_form || '-'}</p>

                            <Label>{t('Commercial Register')}</Label>
                            <p className="mb-2">
                                {[registration.register_type, registration.register_number].filter(Boolean).join(' ') || '-'}
                                {registration.court ? ` (${registration.court})` : ''}
                            </p>

                            <Label>{t('Registration Date')}</Label>
                            <p className="mb-2">
                                {data.registration_date
                                    ? dateUtils.convertDateToDate(data.registration_date, INTERNATIONAL_DATE_FORMAT)
                                    : '-'}
                            </p>

                            <Label>{t('Registered Capital')}</Label>
                            <p className="mb-2">
                                {capital
                                    ? `${formatMoney(capital.amount, capital.currency)}${capital.kind ? ` (${capital.kind})` : ''}`
                                    : '-'}
                            </p>
                        </dl>
                    </Col>
                    <Col md="6">
                        <dl>
                            <Label>{t('Address')}</Label>
                            <p className="mb-2">{formatAddress(data.address)}</p>

                            <Label>{t('Website')}</Label>
                            <p className="mb-2">
                                {data.contact_data?.website ? (
                                    <a href={data.contact_data.website} target="_blank" rel="noopener noreferrer">
                                        {data.contact_data.website}
                                    </a>
                                ) : '-'}
                            </p>

                            <Label>{t('Phone')}</Label>
                            <p className="mb-2">{data.contact_data?.phone_number || '-'}</p>

                            <Label>{t('Entity ID')}</Label>
                            <p className="mb-2">{data.entity_id || '-'}</p>
                        </dl>
                    </Col>
                    {data.purpose && (
                        <Col sm="12">
                            <Label>{t('Purpose')}</Label>
                            <p className="mb-0 text-muted">{data.purpose}</p>
                        </Col>
                    )}
                </Row>
            </Accordion.Body>
        </Accordion.Item>
    );
};

export default withNamespaces()(GeneralInfo);
